module.exports = __webpack_public_path__ + "902522af3b4a3b35cd37f678ca813a44.jpg";